export async function getYoutubeData() {
    const apiKey = process.env.VUE_APP_API_KEY;
    const response = await fetch('https://www.googleapis.com/youtube/v3/channels?part=statistics&id=UCIV0tE4cC3Ufk44-KVZqv7w&key=' + apiKey);
    return await response.json();
}